export default __webpack_public_path__ + "static/media/logo1.141f9836.webp";